<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="600">
    <v-card v-if="clonedValues != null">
      <ODialogBar title="Selecionar Redes Wifi..." @close="dismiss" />
      <v-card-text class="pa-0">
        <OAutocompleteMultiple
          label="Buscar redes..."
          :filter.sync="txtFilter"
          :filteredItems="filteredItems"
          v-model="clonedValues"
          innerListClass="h-300 overflow-y-scroll"
        />
      </v-card-text>
      <ODialogButtons
        class="pa-6"
        @apply="apply"
        @cancel="dismiss"
        txtApply="Salvar"
      />
    </v-card>
  </ODialog>
</template>

<script>
import OAutocompleteMultiple from 'oderon-vue/cpts/forms/OAutocompleteMultiple.vue'
import { matchAnyLike } from 'oderon-commons/src/utils.js'
import { WifiNetwork } from '../../../models'
import { WifiAssoc } from '../../../models/wifi'

export default {
  components: { OAutocompleteMultiple },
  data() {
    return {
      vehicleId: null,
      clonedValues: null,
      txtFilter: null,
      allItems: []
    }
  },
  computed: {
    filteredItems() {
      return this.allItems.filter((x) => {
        return matchAnyLike(this.txtFilter, x.title, x.subtitle, x.rightChip)
      })
    }
  },
  methods: {
    open(vehicleId) {
      this.vehicleId = vehicleId
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    async fetchData() {
      let { rows } = await WifiNetwork.findAll()
      this.allItems = rows.map((x) => {
        return { id: x.id, title: x.name, subtitle: x.tags, rightChip: x.ssid }
      })

      let existing = await WifiAssoc.findByVehicle(this.vehicleId)
      this.clonedValues = existing.map((x) => {
        return { id: x.network.id, title: x.network.name }
      })
    },
    apply() {
      let body = { networkIds: this.clonedValues.map((x) => x.id) }
      this.$refs.dialog.$loading(async () => {
        await WifiAssoc.saveByVehicle(this.vehicleId, body)
        this.$snack('Salvo com sucesso')
        this.$refs.dialog.$apply(true)
      })
    }
  }
}
</script>

<style></style>
